import { EditAltIcon } from 'cokitchen-icons';
import React, { useState } from 'react';
import usePricingContext from 'contexts/pricing.context';

const ReviewConversionListDetails = () => {
  const { conversionListFormData, setStep, setSelectedConversionItem } = usePricingContext();

  const defaultShowVendorDetails = conversionListFormData.reduce((result, _, index) => {
    result[index] = false;
    return result;
  }, {} as Record<string, boolean>);
  const [showVendorDetails, setShowVendorDetails] = useState(defaultShowVendorDetails);

  const toggleShowVendorDetails = (idx: number) => {
    const show = showVendorDetails[idx];
    setShowVendorDetails((vendors) => ({
      ...vendors,
      [idx]: !show
    }));
  };

  return (
    <div>
      <div className='flex justify-between mb-6'>
        <h3 className='text-xl font-semibold'>Review meal</h3>
        <p onClick={() => setStep(1)} className='text-[#E60A2B] text-sm font-medium cursor-pointer'>
          {conversionListFormData.length === 1 ? 'Edit' : 'Edit all'}
        </p>
      </div>

      {conversionListFormData.map((vendor, vendorIndex) => {
        const packagingItems = vendor.packaging?.filter((_) => _.quantity && _.ingredient_name);
        return (
          <div key={vendorIndex}>
            <div className='bg-[#F7F7F7E5] border-b border-[#EAEBEB] py-3 mx-[-28px] flex justify-between'>
              <div className='flex flex-col gap-1 pl-[28px]'>
                <div className='flex gap-2'>
                  <p className='text-[16px] font-semibold '>{vendor.name}</p>
                  <span className='px-2 py-1 rounded-[40px] bg-[#EDEDED] text-xs text-gray-12'>
                    {vendor.secton_name}
                  </span>
                </div>
                <span className='text-gray-9 text-sm'>
                  {vendor.no_of_portions}
                  {vendor.portion_type}
                </span>
              </div>
              <div className='flex gap-2 pr-[28px]'>
                <div
                  onClick={() => {
                    setSelectedConversionItem({ ...vendor, itemIndex: vendorIndex });
                    setStep(2);
                  }}
                  className='bg-[#EFF0F0] w-8 h-8 rounded-full flex items-center justify-center cursor-pointer'>
                  <EditAltIcon />
                </div>
                <div
                  onClick={() => toggleShowVendorDetails(vendorIndex)}
                  className='bg-white border border-[#EAEBEB] rounded-[100px] flex items-center justify-center  text-xs font-medium text-[#5E6164] cursor-pointer w-[61px] h-[30px] shadow-sm'>
                  {showVendorDetails[vendorIndex] ? 'Hide' : 'Show'}
                </div>
              </div>
            </div>

            {showVendorDetails[vendorIndex] ? (
              <div className='  py-3'>
                <div className='w-full my-4 flex justify-start items-center bg-[#F4F5F5] p-2 gap-2 '>
                  <span className='font-semibold text-base'>Food items</span>
                </div>
                {vendor.ingredients?.length > 0 ? (
                  vendor.ingredients.map((item, itemIndex) => (
                    <div
                      key={itemIndex}
                      className='flex justify-start items-center border-b-[0.7px] border-[#EDEDEE] py-3 text-sm font-medium gap-1'>
                      <span className='text-gray-12 font-semibold text-sm'>
                        {' '}
                        {item.ingredient_name || item.name}
                      </span>{' '}
                      <span className='text-[#D9D9D9] text-2xl'>•</span>{' '}
                      <span className='text-gray-9 text-sm'>
                        {item.quantity}/{item.ingredient?.unit_type || item.unit_type}
                      </span>
                    </div>
                  ))
                ) : (
                  <div>
                    <p className='text-sm font-medium mt-1'>No Food item</p>
                  </div>
                )}

                <div className='w-full my-4 flex justify-start items-center bg-[#F4F5F5] p-2 gap-2 '>
                  <span className='font-semibold text-base'>Packaging items</span>
                </div>
                {packagingItems?.length > 0 ? (
                  packagingItems.map((item, itemIndex) => (
                    <div
                      key={itemIndex}
                      className='flex justify-start items-center border-b-[0.7px] border-[#EDEDEE] py-3 text-sm font-medium gap-1'>
                      <span className='text-gray-12 font-semibold text-sm'>
                        {' '}
                        {item.ingredient_name}
                      </span>{' '}
                      <span className='text-[#D9D9D9] text-2xl'>•</span>{' '}
                      <span className='text-gray-9 text-sm'>
                        {item.quantity}/{item.ingredient?.unit_type}
                      </span>
                    </div>
                  ))
                ) : (
                  <div>
                    <p className='text-sm font-medium mt-1'>No Packaging item</p>
                  </div>
                )}
              </div>
            ) : null}
          </div>
        );
      })}
    </div>
  );
};

export default ReviewConversionListDetails;
